/**
 * Created by Ning Jiang on 10/25/2018.
 */

import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class TombstoneBonusAttentionController extends ReelStopPresentationController {

    private _bonusPositions:number[];
    private _respinTriggered:boolean;
    private _hasBetWayWin:boolean;
    private _isLooping:boolean;

    constructor(index:number) {
        super(index, "BonusAttention");
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._respinTriggered = data.bonusTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
        this._hasBetWayWin = data.betWins != null && data.betWins.length > 0;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 0 && this._bonusPositions[0] > -1 && !data.quickStop) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BONUS_LANDING);
            this.playBonusSymbolAttention(0, this._bonusPositions[0], true);
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        if(data.reelId === 4) {
            if(this._respinTriggered) {
                SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BONUS_LANDING_JUSTICE_WIN);
            }
            if(this._respinTriggered && this._hasBetWayWin) {
                const timeline:TimelineLite = new TimelineLite();
                timeline.add(this.playBonusSymbolAttention(0, this._bonusPositions[0], false), 0);
                timeline.add(this.playBonusSymbolAttention(4, this._bonusPositions[4], false), 0);
                timeline.add(() => this.dispatchCompleteEvent(data.reelId));
                timeline.play();
            } else {
                this._isLooping = false;
                this.dispatchCompleteEvent(data.reelId);
            }
            return;
        }

        this.dispatchCompleteEvent(data.reelId);

    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private playBonusSymbolAttention(reelId:number, symbolId:number, loop:boolean):Timeline {
        this._isLooping = loop;
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol == null) {
            debugger;
            throw new Error(`TombstoneBonusAttentionController.playBonusSymbolAttention(): Cannot find symbol at reelId = ${reelId}, symbolId = ${symbolId}`);
        }

        symbol.parent.addChild(symbol);
        return symbol.changeState({
            state : TombstoneGameConfig.instance.SYMBOL_STATES.attention,
            replay : true,
            fadeInDuration : 0.5,
            onCompleteCallback : () => {
                if(this._isLooping) {
                    this.playBonusSymbolAttention(reelId, symbolId, true);
                }
            }
        })!;
    }
}